import { QueryConfig } from "store/utils/query-config";

export const chatWidgetDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdAt"]
  }
};
